import React, {useState} from 'react'
import {gql, useMutation,useQuery} from "@apollo/client";

const CREAR_ENTRADA = gql`
mutation crearEntrada($fecha: String, $concepto:String, $cantidad:Int){
   crearEntrada(fecha: $fecha, concepto:$concepto, cantidad:$cantidad){
    _id
    fecha
    concepto
    cantidad
   } 
}`

const GET_ENTRADA = gql `
query getEntradas{
  getEntradas{
    _id
   fecha
   concepto
   cantidad
  } 
}`

const ACTUALIZAR_ENTRADA = gql`
  mutation editarEntrada($id: ID!, $nuevaCantidad: Int) {
    editarEntrada(_id: $id, cantidad: $nuevaCantidad) {
      _id
      fecha
      concepto
      cantidad
    }
  }
`;

const ELIMINAR_ENTRADA = gql `mutation eliminarEntrada($id:ID!){
  eliminarEntrada(_id:$id)
  }`;



function AgregarEntrada() {

  const [editingEntry, setEditingEntry] = useState(null);
  const [nuevaCantidad, setNuevaCantidad] = useState(0);
  const [editarEntrada] = useMutation(ACTUALIZAR_ENTRADA)
  

  const [fecha, setFecha]=useState('');
  const [concepto, setConcepto] = useState('');
  const [cantidad, setCantidad] = useState('');
  const [crearEntrada]=useMutation(CREAR_ENTRADA);
  const entradaSubmit = e=>{
    e.preventDefault()
    const cantidadValue = cantidad === '' ? 0 : parseInt(cantidad);

   
    crearEntrada({variables:{fecha, concepto,cantidad:cantidadValue}});
    setFecha('');
    setConcepto('');
    setCantidad('');


  }

  const {loading, error, data} = useQuery(GET_ENTRADA);
   

    
  const [eliminarEntrada] = useMutation(ELIMINAR_ENTRADA, {
    refetchQueries: [{ query: GET_ENTRADA }]
  });
 


    
  if(loading) return <p>Esperando resultados...</p>;
      if(error) return <p>Error</p>;

      const currentDate = new Date().toISOString().split('T')[0];


      const filterData = data.getEntradas.filter((item) => item.fecha === currentDate);
      const reversedData = filterData.slice().reverse();
      const totalEntradas=data.getEntradas.reduce((acumulador, entrada) => acumulador + entrada.cantidad, 0)
   

 
  return (
    <div>
       <div className="card card-total">
  <h1>Total ingresos</h1>
<h1>{totalEntradas}</h1>

</div>
    <div class="card card-entrada" >
    <div class="card-body">
      <h2> Agregar Ingresos</h2>
      <form onSubmit={entradaSubmit}>
      <input type="date" placeholder='fecha' value={fecha} onChange={evt=>setFecha(evt.target.value)}></input>
      <input placeholder='concepto' value={concepto} onChange={evt=>setConcepto(evt.target.value)}></input>
      <input placeholder='cantidad' value={cantidad} onChange={evt=>setCantidad(parseInt(evt.target.value))}></input>
        <button className="btn btn-entrada">Agregar</button>
          
          </form>  
    </div>
  </div>
  <div class="container">
  <div className="row">   
 {reversedData.map((entrada)=>
    
    <><div className="card card-entrada col-xs-12 col-xl-4 col-sm-6" >
  <div className="card-body">
    <h3 class="card-title">{entrada.concepto}</h3>
    <h4 class="card-text">{entrada.fecha}</h4>
    <h4 class="card-text">{entrada.cantidad}</h4>
    <button className="btn btn-danger" onClick={()=>{
  eliminarEntrada({ variables:{id:entrada._id} });
}}  disabled={loading}>
eliminar
 </button>

 {editingEntry === entrada._id ? (
  <>
  <input
  type="number"
  value={nuevaCantidad}
  onChange={(e) => setNuevaCantidad(parseInt(e.target.value))}
/>
<button
className="btn btn-primary"
onClick={() => {
  editarEntrada({
    variables: { id: entrada._id, nuevaCantidad },
  });
  setEditingEntry(null);
  setNuevaCantidad(0);
}}
>
Guardar
</button>
</>
): (
  <>
    {/* Botón para editar */}
    <button
      className="btn btn-primary"
      onClick={() => {
        setEditingEntry(entrada._id);
        setNuevaCantidad(entrada.cantidad);
      }}


    >
      Editar
    </button>
  </>
)}
  </div>
  
</div>



  </>
 
 
 )};
 
 </div>
 </div>
 
</div>

    

    
  )
}

export default AgregarEntrada;    